import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import config, { API_PKI } from '../../config';

const AdminHeaderComponent = ({ changeLanguage }) => {
  const { t, i18n } = useTranslation();

  const switchLanguage = (lng) => {
    i18n.changeLanguage(lng);
    changeLanguage(lng);
  };
  

  return (
    <div id="header">
      <div id="header-content">
        <a href="/">
            <div>
              <h1 className="toph">{t('header.title')}</h1>
              <h2 className="both">{t('header.subtitle')}</h2>
            </div>
        
        </a>

        <div className="s_l">
          <div className="lang">
            <div id="jflanguageselection">
              <form id="languageForm" className="form-hidden">
                <ul className="jflanguageselection">
            
                      <li id={i18n.language === 'kz' ? "active_language" : ""}>
                        <a
                          id="linkKaz"
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            switchLanguage('kz');
                          }}
                        >
                          <span lang="kz">KZ</span>
                        </a>
                      </li>
                      <li id={i18n.language === 'ru' ? "active_language" : ""}>
                        <a
                          id="linkRus"
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            switchLanguage('ru');
                          }}
                        >
                          <span lang="ru">RU</span>
                        </a>
                      </li>
                
                </ul>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="menu">
        <div id="menu2">
          <ul className="menu-main">
            <li style={{ borderLeftWidth: '0px' }}>
            <Link to="/nm-admin/profile">
              {/* <a href="https://pki.gov.kz/get-sdk/" style={{ color: 'white', textDecoration: 'none' }}> */}
             <a href="" style={{ color: 'white', textDecoration: 'none' }}>
                <h3>{t('NCALayerModuleForm.profile')}</h3>
              </a>
              <span style={{ display: 'block' }}></span>
              </Link>
            </li>
            <li style={{ borderLeftWidth: '0px' }}>
              <Link to="/nm-admin/requests">
                <a href="" style={{ color: 'white', textDecoration: 'none' }}>
                  <h3>{t('NCALayerModuleForm.moduleApplications')}</h3>
                </a>
                <span style={{ display: 'block' }}></span>
              </Link>
            </li>
            <li style={{ borderLeftWidth: '0px' }}>
            <Link to="/nm-admin/reports">
              {/* <a href="https://pki.gov.kz/get-sdk/" style={{ color: 'white', textDecoration: 'none' }}> */}
             <a href="" style={{ color: 'white', textDecoration: 'none' }}>
                <h3>{t('NCALayerModuleForm.adminReports')}</h3>
              </a>
              <span style={{ display: 'block' }}></span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AdminHeaderComponent;


